import { useCallback } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import moment from "moment"
import { Card, CardContent, Chip, Typography, Button } from "@mui/material"
import { Label as LabelIcon } from "@mui/icons-material"

import { GRACE_PERIOD } from "modules/data-cloud/helpers"
import "../style.scss"

const Browse = (props) => {
  const { dataset, preheader, subheader, style, actions, state, toggleExpanded, contactUs, reactivate } = props
  const { id, name, publisher, type, description, expiration } = dataset || {}
  const { expanded } = state

  const CTA = useCallback(() => {
    if (expiration) {
      if (moment(expiration).isBetween(moment().subtract(GRACE_PERIOD, "days"), moment(), "day", "[)")) {
        return <Button className="cta" variant="contained" color="primary" onClick={reactivate}>Re-Activate</Button>
      }
      if (moment(expiration).isSameOrAfter(moment(), "day")) {
        return <Button className="cta" variant="contained" disabled>Subscribed</Button>
      }
    }
    return <Button className="cta" variant="contained" color="primary" onClick={contactUs}>Contact Us</Button>
  }, [contactUs, expiration, reactivate])

  return <Card square className={classNames("dataset browse", { condensed: !expanded, expanded })} style={style} onClick={toggleExpanded}>
    <div className="header">
      <div className="title">
        {preheader}
        <Typography variant="h5" component="h5">{name || id}</Typography>
        {subheader}
      </div>

      <div className="actions">
        {actions}
      </div>
    </div>
    <CardContent className="content">
      <p className="description">{description}</p>
      <div className="bottom-bar">
        <div className="chips">
          <Chip label={<span>Published by <b>{publisher}</b></span>} />
          <Chip className="type" avatar={<LabelIcon />} label={type} />
        </div>
        {CTA()}
      </div>
    </CardContent>
  </Card>
}

Browse.propTypes = {
  dataset: PropTypes.object.isRequired,
  state: PropTypes.shape({
    expanded: PropTypes.bool,
    favourite: PropTypes.bool,
    notifications: PropTypes.bool,
  }).isRequired,
  actions: PropTypes.object,
  style: PropTypes.object,
  preheader: PropTypes.object,
  subheader: PropTypes.object,
  toggleExpanded: PropTypes.func.isRequired,
  contactUs: PropTypes.func.isRequired,
  reactivate: PropTypes.func.isRequired,
}

export default Browse
